import Moment from 'moment';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  AppDatePicker, AppFileUploader, AppRemixIcon, AppTextArea,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import AppInput from '../../../../../components/form/AppInput';
import colors from '../../../../../../constants/colors';
import minions from '../../../../../../minions/minions';
import Translator from '../../../../../components/helpers/Translator';

const PlantEvidenceNewForm = (props) => {
  const { handleAddEvidence } = props;
  const addEvidenceValidationSchema = Yup.object().shape({
    name: Yup.string().required(ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)),
    date: Yup.string().required(ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)),
  });

  return (
    <EvidenceForm>
      <Formik
        initialValues={{
          name: '',
          description: '',
          files: [],
          date: Moment().format('DD/MM/YYYY'),
        }}
        validationSchema={addEvidenceValidationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleAddEvidence}
      >
        {({
          handleSubmit, values, setFieldValue, isSubmitting, errors,
        }) => (
          <div className="p-2">
            <h3><Translator file="module-legalCompliance" name="module.lc.plant-evidence.new" /></h3>
            <AppInput
              title={<Translator file="module-legalCompliance" name="name" />}
              placeholder={<Translator file="module-legalCompliance" name="name.description.compulsory" />}
              icon={<AppRemixIcon icon="double-quotes-l" noVariants />}
              value={values.name}
              onChange={(opt) => setFieldValue('name', opt)}
              error={errors.name}
              isClearable
            />
            <AppTextArea
              title={<Translator file="module-legalCompliance" name="module.lc.evidence.description" />}
              placeholder={<Translator file="module-legalCompliance" name="name.description.compulsory" />}
              icon={<AppRemixIcon icon="align-left" noVariants />}
              onChange={(opt) => setFieldValue('description', opt)}
              value={values.description}
            />
            <div className="row">
              <div className="col-lg-6">
                <AppDatePicker
                  title={<Translator file="module-legalCompliance" name="date" />}
                  value={values.date}
                  onChange={(opt) => setFieldValue('date', opt)}
                  popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                />
              </div>
              <div className="col-lg-6">
                <EvidenceFileList>
                  {values.files.map((f) => (
                    <li
                      key={f.name}
                      title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="click.delete" />)}
                      onClick={() => setFieldValue('files', values.files.filter((file) => file.name !== f.name))}
                    >
                      <AppRemixIcon
                        className="pointer mr-3"
                        icon="delete-bin"
                        color={colors.danger}
                      />
                      {minions.files.fileIcon(f.name, true, null, 'mr-2')}
                      {f.name}
                    </li>
                  ))}
                </EvidenceFileList>
                <div className="pt-2">
                  <AppFileUploader
                    isMulti
                    placeholder={
                      values.files.length === 0
                        ? ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="select.one.multiple.files" />)
                        : ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="select.number.of.elements" variables={{ elements: values.files.length }} />)
}
                    onChange={(opt) => setFieldValue('files', [...values.files, ...opt])}
                    btnText={<Translator file="general" name="search..." />}
                  />
                </div>

              </div>
            </div>
            <span
              className={`btn btn-primary float-right mt-2 ${isSubmitting ? 'disabled' : ''}`}
                        // onClick={() => (!isSubmitting ? handleSubmit : undefined)}
              onClick={handleSubmit}
            >
              <Translator file="user" name="user.obligation.evidence.create" />
            </span>
          </div>
        )}
      </Formik>
    </EvidenceForm>
  );
};
export default PlantEvidenceNewForm;

const EvidenceForm = styled.div`
  h3{
    font-size: 13px;
    font-weight: bold;
  }
`;
const EvidenceFileList = styled.ul`
  list-style: none;
  margin: 10px 0 0 0;
  padding-left: 6px;
  li{
    cursor: pointer;
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.grey300};
    padding: 8px 0;
    span{
      font-size: 12px;
      color: ${colors.primary};
    }
  }
  li:first-child{
    border-top: 0;
  }
`;
